import { getJSON } from "../helpers/core";

export const isValidSIMNumber = (sim, network) =>
  getJSON(`SIM/IsValidSIMNumber/${sim}`, {
    network,
  });
